import { isIntendedOnNewTab } from "@circle-react/helpers/browserHelpers";
import { Link } from "@tanstack/react-router";
import { noop } from "lodash";

import { useIsMobileShellEnabled } from "@/react/components/Mobile/hooks/useIsMobileShellEnabled";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { usePreviousLocationState } from "@/react/hooks/usePreviousLocationState";

interface ItemWrapperProps {
  children: React.ReactNode;
  onClose: () => void;
  uuid: string;
}

export const ItemWrapper = ({
  children,
  onClose = noop,
  uuid,
}: ItemWrapperProps) => {
  const previousLocationState = usePreviousLocationState();

  const isMobileShellEnabled = useIsMobileShellEnabled();

  return (
    <Link
      className={classNames(
        "my-0.5 flex h-14 cursor-pointer items-start justify-between rounded-xl bg-primary px-4 py-2 first:mt-0 hover:bg-hover",
        {
          "dark:hover:bg-secondary": isMobileShellEnabled,
        },
      )}
      onClick={e => {
        if (!isIntendedOnNewTab(e)) {
          onClose();
        }
      }}
      to="/messages/$uuid"
      params={{ uuid }}
      state={previousLocationState}
      data-testid="chat-room-dm-list"
    >
      {children}
    </Link>
  );
};
